import { useNavigate, useLocation } from "react-router-dom";

export default function DemoPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    // If we came from SPA page, go back to that section
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      // fallback to default SPA section if opened directly
      navigate("/exploreNetraa");
    }
  };

  return (
    <div className="w-screen h-screen bg-black flex justify-center items-center relative overflow-hidden">
      {/* Close button */}
      <button
        onClick={handleClose}
        className="absolute top-3 right-6 z-50 text-white text-2xl font-bold"
      >
        &times; {/* Close icon */}
      </button>

      {/* Fullscreen video */}
      <video
        src="/videos/demo.mp4" // Replace with your video path or URL
        controls
        autoPlay
        className="w-full h-full object-contain relative z-10"
      />
    </div>
  );
}